import React, { useState } from "react";
import {
  Checkbox,
  FormControl,
  FormGroup,
  Divider,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const CheckBoxList = ({
  receiptFileName,
  onCheckboxChange,
  customizedItems,
  checkedItems,
  setIsValid,
  isValid,
}: any) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
    },
  }));
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");

  const handlerScanBorCode = (value: string) => {
    if (!value.trim()) return;
    onCheckboxChange(value, true);
    setTimeout(() => {
      setInputValue("");
    }, 50);
  };

  return (
    <>
      <TextField
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handlerScanBorCode(inputValue);
          }
        }}
        size="small"
        autoFocus
        value={inputValue}
        label="آیتم"
      />
      <div className={classes.root}>
        <FormControl>
          <FormGroup>
            {customizedItems.CATALOG.length > 0 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.includes("CATALOG")}
                    onChange={(e) =>
                      onCheckboxChange("CATALOG", e.target.checked)
                    }
                  />
                }
                label="کاتالوگ و بروشور"
              />
            )}
            {customizedItems.BRANDED_LABEL.length > 0 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.includes("BRANDED_LABEL")}
                    onChange={(e) =>
                      onCheckboxChange("BRANDED_LABEL", e.target.checked)
                    }
                  />
                }
                label="لیبل"
              />
            )}
            {customizedItems.VISIT_CARD.length > 0 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.includes("VISIT_CARD")}
                    onChange={(e) =>
                      onCheckboxChange("VISIT_CARD", e.target.checked)
                    }
                  />
                }
                label="کارت ویزیت"
              />
            )}
            {customizedItems.DISCOUNT_CARD.length > 0 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.includes("DISCOUNT_CARD")}
                    onChange={(e) =>
                      onCheckboxChange("DISCOUNT_CARD", e.target.checked)
                    }
                  />
                }
                label="کارت تخفیف"
              />
            )}

            {customizedItems.GIFT_PACK.length > 0 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.includes("GIFT_PACK")}
                    onChange={(e) =>
                      onCheckboxChange("GIFT_PACK", e.target.checked)
                    }
                  />
                }
                label="پک هدیه"
              />
            )}

            {receiptFileName && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedItems.includes("RECEPT_FILE_NAME")}
                    onChange={(e) =>
                      onCheckboxChange("RECEPT_FILE_NAME", e.target.checked)
                    }
                  />
                }
                label="فایل فاکتور"
              />
            )}

            <Divider />
            <FormControlLabel
              control={
                <Checkbox
                  // checked={isValid}
                  onChange={() => setIsValid(!isValid)}
                />
              }
              label="تایید بسته بندی بدون آیتم همراه"
            />
          </FormGroup>
        </FormControl>
      </div>
    </>
  );
};

export default CheckBoxList;
